const baseURL='https://testapi.aiworldcommunity.com/admin/api';
module.exports={baseURL};